import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { Col, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { __MessageTypes } from '../../../../../../common/Dictionaries';
import { isNullUndefinedOrEmpty, showMessage } from '../../../../../../common/Helpers';
import PropTypes from 'prop-types';
import MessageBox from '../../../../../Common/Message/MessageBox';
import { generateNewEdp } from '../../../../../../services/sPay/edpConfig.service';
import CLabel from '../../../../../Common/CLabel';
import { DatePicker, DayOfWeek, defaultDatePickerStrings } from '@fluentui/react';
import CValidator from '../../../../../Common/CValidator';

const SidePanelSelectEndDateEP = (props) => {
    const { t } = useTranslation();

    const { 
        inputParam_ElementId = null,
        inputParam_IsPanelOpen = null,
        inputParam_SetterIsPanelOpen = null,
        inputParam_NextValidEdpDate = null
    } = props;

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const [selectedDate, setSelectedDate] = useState(null);
    const [validateEnabled, setValidateEnabled] = useState(false);
    

    const onDismissPanel = () => {
        setValidateEnabled(false);
        showMessage(setMessageConfig, false, null, null)
        inputParam_SetterIsPanelOpen && inputParam_SetterIsPanelOpen(false)
    };

    const onClosePanel = () => {
        onDismissPanel();
    };

    const handleSaveDate = async () => {
        if (!isNullUndefinedOrEmpty(selectedDate)) {
            await generateNewEdp(inputParam_ElementId, selectedDate).then(async (response) => {
                if (response.data.succeeded) {
                    if (response.data.data.result) {
                        window.location.href = `/PrepareEdP/${inputParam_ElementId}/${response.data.data.itemId}`
                    }
                    else {
                        if (response.data.data.l_validations.length > 0) {
                            showMessage(setMessageConfig, true, __MessageTypes.ERROR, response.data.data.l_validations)
                        }
                        else {
                            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                        }
                    }
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                }
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
            });
        }
        else {
            setValidateEnabled(true);
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-requireddatanotset'));
        }
    }

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12} className="message-verybottom-panel-medium">
                        <MessageBox
                            inputParam_Message={ t('data-lang-msg-notmonthlyep') }
                            inputParam_Display={ true }
                            inputParam_MessageType={ __MessageTypes.WARNING }
                            inputParam_SetterMessage={ null }
                        /> 
                        <MessageBox
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                        /> 
                    </Col>
                    <Col xl={12}>
                        <PrimaryButton onClick={ handleSaveDate }>{ t('data-lang-btn-save') }</PrimaryButton>
                        <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                    </Col>
                </Row>
    }

    const onFormatDate = (date) => {
        if (!date) return "";

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    };

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-boxname-selectenddataep') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                <Row>
                    <Col xs={12}>
                        <div>
                            <CLabel labelText={ t('data-lang-lbl-todate') } />
                            <DatePicker
                                firstDayOfWeek={DayOfWeek.Monday}
                                strings={defaultDatePickerStrings}
                                value={selectedDate}
                                onSelectDate={setSelectedDate}
                                formatDate={onFormatDate}
                                minDate={!isNullUndefinedOrEmpty(inputParam_NextValidEdpDate) ? inputParam_NextValidEdpDate : undefined} 
                                styles={{
                                    root: { width: 320 },
                                }}
                            />
                            {
                                validateEnabled &&
                                <CValidator isInValid={ isNullUndefinedOrEmpty(selectedDate) } />
                            }
                        </div>
                    </Col>
                </Row>
            </Panel>
        </div>
    );
};

SidePanelSelectEndDateEP.propTypes = {
    inputParam_ElementId: PropTypes.number.isRequired,
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,
    inputParam_NextValidEdpDate: PropTypes.object.isRequired,
};

export default SidePanelSelectEndDateEP;